var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusAfficher)?_c('div',{staticClass:"formulaire-status"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_c('div',[_vm._v("Données non sauvegardées")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }